module.exports = __webpack_public_path__ + "static/ahsetyy-c8cc0a8d58b6e4337a8d6e8dd723cdae.jpg";